import { Box, Button, Select, Text, useToast } from "@chakra-ui/react";
import axios from "axios";
import * as React from "react";
import { api } from "../../config";

const months = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December"
];

const BlockedMonths: React.FC = () => {
  const [month, setMonth] = React.useState<number | null>(null);
  const [year, setYear] = React.useState<number | null>(null);
  const toast = useToast();

  const handleUnblock = async () => {
    try {
      if (!month || !year) {
        throw new Error("Please select both month and year");
      }

      // ⚠️ Confirmation
      const confirm = window.confirm(
        `Are you sure you want to unblock ${months[month - 1]} ${year}?`
      );
      if (!confirm) return;

      const res = await axios.post(
        `${api}/blocks/delete-by-month-year`,
        { month, year },
        { withCredentials: true }
      );

      toast({
        title: `✅ ${res.data.deletedCount} blocks removed`,
        status: "success",
        position: "bottom-right",
      });
    } catch (error: any) {
      toast({
        title: error.message,
        status: "error",
        position: "bottom-right",
      });
    }
  };

  return (
    <Box p="6">
      <Text fontSize="xl" mb="4">
        Unblock Month for All Students
      </Text>

      <Select
        placeholder="Select Month"
        onChange={(e) => setMonth(Number(e.target.value))}
        mb="3"
      >
        {months.map((m, i) => (
          <option key={i} value={i + 1}>{m}</option>
        ))}
      </Select>

      <Select
        placeholder="Select Year"
        onChange={(e) => setYear(Number(e.target.value))}
        mb="3"
      >
        {[2024, 2025, 2026, 2027].map((y) => (
          <option key={y} value={y}>{y}</option>
        ))}
      </Select>

      <Button colorScheme="red" onClick={handleUnblock}>
        Unblock Month
      </Button>
    </Box>
  );
};

export default BlockedMonths;